import EventSessions from "./components/EventSessions";
import LiveVideo from "./components/LiveVideo";
import SponsorsList from "./components/Sponsors/SponsorsList";

const App = () => {
  return (
    <div id="main-area" className="flex flex-col">
      <LiveVideo />
      <EventSessions />
      <SponsorsList />
    </div>
  );
};
export default App;
